import type { StreamMessage } from './messagesApi';

function formatTime(value: string): string {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function MessageBubble({ message }: { message: StreamMessage }) {
  const isUser = message.sender === 'user';
  const isSystem = message.sender === 'system';
  return (
    <div
      data-testid="message-bubble"
      data-sender={message.sender}
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        padding: '6px 10px',
      }}
    >
      <div
        style={{
          maxWidth: '72%',
          borderRadius: 14,
          padding: '9px 12px',
          border: '1px solid var(--border)',
          background: isUser ? 'var(--orange-dim, rgba(249,115,22,0.12))' : isSystem ? 'var(--surface2)' : 'var(--surface)',
          color: 'var(--text)',
          opacity: message.optimistic ? 0.68 : 1,
          marginLeft: isUser ? 'auto' : 0,
        }}
      >
        <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5, fontSize: 'var(--text-sm)' }}>{message.body}</div>
        <div className="mono muted" style={{ marginTop: 5, fontSize: 'var(--text-xs)', textAlign: isUser ? 'right' : 'left' }}>
          {message.optimistic ? 'sending...' : formatTime(message.created_at)}
          {message.error ? ` - ${message.error}` : ''}
        </div>
      </div>
    </div>
  );
}
